"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function gbx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.7743 8.2545V9.7995H8.24925C7.79175 9.7995 7.2285 9.96 6.80925 10.257C6.2895 10.626 5.99925 11.1788 5.99925 12.0023C5.99925 12.8258 6.2895 13.3785 6.80925 13.7475C7.2285 14.0445 7.79175 14.205 8.24925 14.205H9.74925V15.75H8.24925C7.42985 15.7419 6.6318 15.4877 5.95875 15.0203C5.03775 14.3663 4.5 13.3418 4.5 12.0023C4.5 10.6628 5.03775 9.63825 5.95875 8.98425C6.63157 8.51693 7.42935 8.26267 8.2485 8.2545H11.7743ZM8.02425 12.891V11.346H11.7743V15.75H10.275V12.891H8.02425ZM14.25 9.795V8.25H19.5V15.75H12.7485V9.80025H14.2485V14.2042H18V9.79575L14.25 9.795Z", fill: color }),
        React.createElement("path", { d: "M11.7743 8.2545V9.7995H8.24925C7.79175 9.7995 7.2285 9.96 6.80925 10.257C6.2895 10.626 5.99925 11.1788 5.99925 12.0023C5.99925 12.8258 6.2895 13.3785 6.80925 13.7475C7.2285 14.0445 7.79175 14.205 8.24925 14.205H9.74925V15.75H8.24925C7.42985 15.7419 6.6318 15.4877 5.95875 15.0203C5.03775 14.3663 4.5 13.3418 4.5 12.0023C4.5 10.6628 5.03775 9.63825 5.95875 8.98425C6.63157 8.51693 7.42935 8.26267 8.2485 8.2545H11.7743ZM8.02425 12.891V11.346H11.7743V15.75H10.275V12.891H8.02425ZM14.25 9.795V8.25H19.5V15.75H12.7485V9.80025H14.2485V14.2042H18V9.79575L14.25 9.795Z", fill: color }));
}
exports["default"] = gbx;
//# sourceMappingURL=gbx.js.map